/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SnsAccountError
 */
export interface SnsAccountError {
    /**
     * sns 계정 에러 id
     * @type {number}
     * @memberof SnsAccountError
     */
    'snsAccountErrorId': number;
    /**
     * 이름
     * @type {string}
     * @memberof SnsAccountError
     */
    'name': SnsAccountErrorNameEnum;
}

export const SnsAccountErrorNameEnum = {
    UserUnauthorized: 'user_unauthorized',
    UserChallengeRequired: 'user_challenge_required'
} as const;

export type SnsAccountErrorNameEnum = typeof SnsAccountErrorNameEnum[keyof typeof SnsAccountErrorNameEnum];


